import { VerifyAccountRequest } from 'src/stores/phoneNumberLogin/types';
import { Platform } from 'src/types/Platform';
import { SMS_VERIFIED_METHOD_TYPES } from 'src/types/register';
import { SocialToken } from 'src/types/Token';
import { getServerSideLanguageCode } from 'src/utils/language';

export const isKmcPhoneToken = (socialToken: SocialToken | undefined): boolean => {
  return (
    !!socialToken &&
    'smsVerification' in socialToken &&
    socialToken.smsVerification?.method === SMS_VERIFIED_METHOD_TYPES.KMC
  );
};

export const createKmcVerifyAccountRequest = (kmcResultKey: string): VerifyAccountRequest => ({
  localeInfo: {
    countryCode: null,
    languageCode: getServerSideLanguageCode().toLowerCase(),
  },
  kmcVerification: {
    resultKey: kmcResultKey,
  },
  platform: Platform.WebClient,
});
